import React from 'react'
import { CompanyInfo } from 'pages/manufacturers'
import { CheckMarkBubble } from 'images/icons'

interface IProps {
  value?: string | null
  manufacturer: CompanyInfo
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const ManufacturerOption: React.FC<IProps> = ({ manufacturer, value, onChange }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e)
    }
  }

  const isChecked = manufacturer.id === value

  return (
    <label className="manufacturer-option block">
      <span className="sr-only">{manufacturer.name}</span>

      <input
        className="sr-only"
        type="radio"
        name="manufacturer"
        id={manufacturer.id}
        value={manufacturer.id}
        checked={isChecked}
        onChange={handleChange}
      />
      <div
        className="manufacturer-option-content flex flex-col justify-center px-10 pt-10 pb-25 bg-gray-100 border-1 border-transparent transition-colors duration-300 ease-in-out"
        aria-hidden
      >
        <span className="block self-end">
          <CheckMarkBubble size={25} checked={isChecked} />
        </span>
        <img style={{ width: 100 }} className="self-center mt-50" src={manufacturer.logo} alt="" />
        <span className="mt-45 text-12 leading-14 tracking-0.32 text-center text-gray-400">
          {manufacturer.name}
        </span>
      </div>
    </label>
  )
}

export default ManufacturerOption
